"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var row_type_1 = __importDefault(require("../../constants/row-type"));

var ColumnUtils = __importStar(require("../column"));

var ArrayUtils = __importStar(require("../array"));

var UtilsLabel = __importStar(require("../label"));

function getNewEmptyRow() {
  return {
    type: row_type_1.default.KEY_VALUE,
    content: {
      columns: []
    }
  };
}

exports.getNewEmptyRow = getNewEmptyRow;

function getNewEmptyRowByStructure(structure) {
  var row_title = structure.row_title,
      columns = structure.columns;
  return {
    type: row_type_1.default.KEY_VALUE,
    label: row_title ? UtilsLabel.create(row_title) : null,
    content: {
      columns: ColumnUtils.createByStructures(columns)
    }
  };
}

exports.getNewEmptyRowByStructure = getNewEmptyRowByStructure;

function addColumn(data, column) {
  var columns = getColumns(data);
  var newColumns = lodash_1.default.concat(columns, column);
  var content = Object.assign({}, data.content, {
    columns: newColumns
  });
  var row = Object.assign({}, data, {
    content: content
  });
  return row;
}

exports.addColumn = addColumn;

function getColumns(data) {
  return lodash_1.default.get(data, 'content.columns', []);
}

exports.getColumns = getColumns;

function getFirstColumn(data) {
  return lodash_1.default.get(data, 'content.columns[0]', null);
}

exports.getFirstColumn = getFirstColumn;

function getDifferentColumns(data, column) {
  var columns = getColumns(data);
  var result = [];
  lodash_1.default.forEach(columns, function (_column) {
    if (!ColumnUtils.checkEqual(column, _column)) {
      result.push(_column);
    }
  });
  return result;
}

exports.getDifferentColumns = getDifferentColumns;

function getColumnByIndex(data, index) {
  var columns = getColumns(data);
  return columns[index];
}

exports.getColumnByIndex = getColumnByIndex;

function changeColumn(data, index, column) {
  if (!column) {
    return data;
  }

  var columns = getColumns(data);
  var newColumns = lodash_1.default.clone(columns);

  if (lodash_1.default.isArray(column)) {
    var temp = [];
    temp = lodash_1.default.concat(temp, newColumns.slice(0, index));
    temp = lodash_1.default.concat(temp, column);
    temp = lodash_1.default.concat(temp, newColumns.slice(index + 1));
    newColumns = temp;
  } else {
    newColumns[index] = column;
  }

  var content = Object.assign({}, data.content, {
    columns: newColumns
  });
  var row = Object.assign({}, data, {
    content: content
  });
  return row;
}

exports.changeColumn = changeColumn;

function removeColumn(data, index) {
  var columns = getColumns(data);
  var newColumns = ArrayUtils.removeByIndex(columns, index);
  var content = Object.assign({}, data.content, {
    columns: newColumns
  });
  var row = Object.assign({}, data, {
    content: content
  });
  return row;
}

exports.removeColumn = removeColumn;